module.exports = __webpack_public_path__ + "img/xmlc.ecf22786.png";